const texts = {
  baseStyle: {},
  variants: {},
}

export default texts;